"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class InvalidSurveyError extends client_library_1.ExtendableError {
    constructor() {
        super('Survey is invalid');
    }
}
exports.default = InvalidSurveyError;
//# sourceMappingURL=InvalidSurveyError.js.map